import { Rect } from '../../drawing';
import { ChantContext } from '../../gregorio-chant/ChantContext';
import { DistanceConverter } from '../distances/DistanceConverter';

/*
 * ChantLayoutElement
 */
export abstract class ChantLayoutElement {
  private _bounds: Rect = Rect.createEmpty();
  protected _context: ChantContext;
  protected readonly _distanceConverter: DistanceConverter;
  protected _debug = false;

  constructor(
    context: ChantContext,
  ) {
    this._context = context;
    this._distanceConverter = new DistanceConverter(context);
  }

  get bounds(): Rect {
    return this._bounds;
  }

  set bounds(value: Rect) {
    this._bounds = value;
  }

  get top(): number {
    return this.bounds.y;
  }

  public abstract performLayout(...args: any[]): void;

  // TODO: for future canvas implementation
  // public abstract draw(): void;

  protected drawDebugBounds(): SVGElement {
    const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
    rect.setAttribute('x', String(this.bounds.x));
    rect.setAttribute('y', String(this.bounds.y));
    rect.setAttribute('width', String(this.bounds.width));
    rect.setAttribute('height', String(this.bounds.height));
    rect.setAttribute('fill', 'none');
    rect.setAttribute('stroke', 'red');
    rect.setAttribute('stroke-width', '1');
    return rect;
  }

  public createSvgFragments(): SVGElement[] {
    const fragments = [];
    if (this._context.debugMode || this._debug) {
      fragments.push(this.drawDebugBounds());
    }
    return fragments;
  }
}
